import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { TokenService } from './services/token.service';
import { AccessTokenInterceptor } from './interceptors/access-token.interceptor';
import { RefreshAccessInterceptor } from './interceptors/refresh-access.interceptor';
import { EmployeeAccessTokenInterceptor } from './interceptors/employee-access-token.interceptor';
import { ExtendImpersonationTokenInterceptor } from './interceptors/extend-impersonation-token.interceptor';
import { AppExtendImpersonationSessionDialogModule } from '~shared/components/extend-impersonation-session-dialog/extend-impersonation-session-dialog.module';

@NgModule({
  providers: [
    TokenService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccessTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EmployeeAccessTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshAccessInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExtendImpersonationTokenInterceptor,
      multi: true,
    },
  ],
  imports: [
    AppExtendImpersonationSessionDialogModule
  ]
})
export class IdentityModule {}
